import React from "react";
import {animated} from "react-spring";
import * as PropTypes from "prop-types";

export class BuyTickets extends React.Component {
    render() {
        return <section id="buy-tickets" className="section-with-bg">
            <animated.div style={this.props.style} className="container">

                <div className="section-header">
                    <h2>Buy Tickets</h2>
                </div>

                {!this.props.tbd && this.props.tickets && this.props.tickets.map(ticket =>{
                    return <>
                        <div className="row" style={{marginBottom: "20px"}}>
                            <animated.div style={this.props.style} className="col-lg-8 offset-lg-2">
                                <div className="card mb-5 mb-lg-0">
                                    <div className="card-body">
                                        <h5 className="card-title text-muted text-uppercase text-center">{ticket.level}</h5>
                                        <h6 className="card-price text-center">{ticket.price}</h6>
                                        <p>{ticket.subtitle}</p>
                                        <hr/>
                                        <ul className="fa-ul">
                                            {ticket.stuff && ticket.stuff.map(thing =>
                                                <li className={thing.no ? "text-muted" : ""}>
                                            <span className="fa-li">
                                                <i className={thing.no ? "fa fa-times" : "fa fa-check"}/>
                                            </span>{thing.feature}
                                                </li>)
                                            }
                                        </ul>
                                        <hr/>
                                        <div className="text-center">
                                            <button disabled={ticket.soldout} type="button" className="btn" onClick={()=>{
                                                if(!ticket.soldout){
                                                    document.location.href = ticket.href;
                                                }
                                            }}>
                                                {ticket.soldout && "Sold Out"}
                                                {ticket.soldout  || (ticket.price === "Free" ? "Register Now" : "Buy Now")}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </animated.div>
                        </div>
                    </>
                })}
            </animated.div>
        </section>;
    }
}

BuyTickets.propTypes = {
    style: PropTypes.any,
    things: PropTypes.array,
    subtitle: PropTypes.string,
    level: PropTypes.string,
    price: PropTypes.string,
    stuff: PropTypes.array
};
